var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "button button--small button--primary button--cockpit",
          on: {
            click: function ($event) {
              _vm.open = true
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("cockpit.progress.select_learning_goal_title")))]
      ),
      _vm._v(" "),
      _vm.open
        ? _c("learning-goals-for-block-modal", {
            attrs: {
              "stream-code": _vm.streamCode,
              blocks: _vm.blocks,
              "block-content-path": _vm.blockContentPath,
            },
            on: {
              close: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }